<script>
  export let model;
  import RowsContainer from "../container/RowsContainer.svelte";
  import StepperHeadline from "../stepper/StepperHeadline.svelte";
  import Input from "../ui/Input.svelte";
  import Select from "../ui/Select.svelte";

  import Image from "../display/Image.svelte";

  const list = [
    { text: "Physical Product", value: "physical product", isGroup: true },
    { text: "Software", value: "software", isGroup: true },
    { text: "App", value: "app" },
    { text: "API", value: "api" },
    { text: "SaaS", value: "saas" },
    { text: "Service", value: "service", isGroup: true },
    { text: "Agency", value: "agency" },
    { text: "Coaching", value: "coaching" },
    { text: "Consulting", value: "consulting" },
    { text: "Freelancer", value: "freelancer" },
    { text: "Online Course", value: "online course" },
    { text: "Other", value: "other", isGroup: true },
    { text: "Community", value: "community" },
    { text: "Non-Profit", value: "non-profit" },
    { text: "Organization", value: "organization" }
  ];

</script>

<StepperHeadline>
  <h1>
    Name your
    <span class="text-yellow">business</span>
  </h1>
  <p>
    Pick your type of business and tell us how you’ve named your product or
    service, so we can put it on your visuals.
  </p>
</StepperHeadline>
<RowsContainer>
  <div />
  <div class="text-left">
    <Input
      class="mb-8"
      bind:model={model.name}
      label="What’s the name of your business?"
      placeholder="Example: Proposal Ninja"
      hint="No name yet? Use a main feature and add an adjective or word to it." />

    <Select
      bind:model={model.businessType}
      required={true}
      {list}
      label="What type of business are you running?"
      placeholder="Choose what fits best" />
  </div>
  <div />
</RowsContainer>
